// Näited funktsionaalharmoonia järgnevuste kohta. Koostanud: Andres Lemba
// Harjutuste hulgas on kasutatud harjutusi kogumikust Virgo Sillamaa "Kõlakool"


export const dictations = [

    // Andres Lemba algsed harjutused  --------------

    {
        title: "1",
        soundFile: "/sounds/chords/functions/Fun1-1.mp3",
        functions: [ ["T"], ["D"], ["T"] ]  // functions by bars, can be several by bar
    },

    {
        title: "2",
        soundFile: "/sounds/chords/functions/Fun1-2.mp3",
        functions: [ ["T"], ["T"], ["D"] ]
    },
    {
        title: "3",
        soundFile: "/sounds/chords/functions/Fun1-3.mp3",
        functions: [ ["T"],	["T"],	["D"],	["D"],	["T"],	["T"],	["D"] ]
    },
    {
        title: "4",
        soundFile: "/sounds/chords/functions/Fun1-4.mp3",
        functions: [ ["T"],	["D"],	["T"],	["T"],	["D"],	["D"],	["T"] ]
    },

    {
        title: "5",
        soundFile: "/sounds/chords/functions/Fun1-5.mp3",
        functions: [ ["T"],	["D"],	["T"],	["T"],	["D"],	["T"],	["D"] ]
    },

    {
        title: "6",
        soundFile: "/sounds/chords/functions/Fun1-6.mp3",
        functions: [ ["T"],	["D"],	["T"],	["D"],	["T"],	["T"],	["D"], ["D"] ]
    },

    {
        title: "7",
        soundFile: "/sounds/chords/functions/Fun1-7.mp3",
        functions: [ ["T"],	["D"],	["T"],	["D"],	["T"],	["T"],	["D"], ["T"] ]
    },

    {
        title: "8",
        soundFile: "/sounds/chords/functions/Fun1-8.mp3",
        functions: [ ["T"],	["T"],	["D"],	["D"],	["T"],	["D"],	["T"], ["D"] ]
    },

    {
        title: "9",
        soundFile: "/sounds/chords/functions/Fun1-9.mp3",
        functions: [ ["T"],	["D"],	["T"],	["D"],	["T"],	["T"],	["T"], ["D"] ]
    },

    {
        title: "10",
        soundFile: "/sounds/chords/functions/Fun1-10.mp3",
        functions: [ ["T",  "D"],	["T"],	["T"], ["D"]]
    },

    // Virgo Sillamaa "Kõlakoolist"

    // T ja D

    {
        title: "D1.1",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.. Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.1.mp3",
        functions: [ ["T"],	["D"],	["T"],	["D"],	["T"],	["D"],	["T", "D"], ["T"] ]
    },

    {
        title: "D1.6",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.6.mp3",
        functions: [ ["T"],	["D"],	["T"] ]

    },

    {
        title: "D1.7",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.7.mp3",
        functions: [ ["T"],	["D"],	["T"] ]

    },

    {
        title: "D1.8",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.8.mp3",
        functions: [ ["T"],	["T"],	["D"], ["D"],  ["T"],	["T"],	["D"], ["D"],  ["T"],	["T"],	["T", "D"], ["T"],]
    },

    {
        title: "D1.10",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.10.mp3",
        functions: [ ["T"],	["T"],	["D"], ["D"], ["T"],	["T"],	["D"], ["D"], ["T"]  ]

    },

    {
        title: "D1.13",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.13.mp3",
        functions: [ ["T"],	["D"],	["T"], ["T"] ]

    },

    {
        title: "D1.16",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal..",
        soundFile: "/sounds/chords/functions/D1.16.mp3",
        functions: [ ["T"],	["T"],	["D"], ["D"], ["T"] ]

    },

    {
        title: "D1.17",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.17.mp3",
        functions: [ ["T"],	["D"],	["T"], ["D"], ["T"] ]

    },

    {
        title: "D1.19",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.19.mp3",
        functions: [ ["T"],	["D"],	["T"], ["D"],  ["T"],	["D"],	["T"] ]
    },



    {
        title: "D1.28",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D1.28.mp3",
        functions: [ ["T"],	["D"],	["T"], ["D"],  ["T"]]
    },

    // T-S-D


    {
        title: "D2.1",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.1.mp3",
        functions: [ ["T", "S"],	["D"],	["T", "S"], ["D"],  ["T"] ]
    },


    {
        title: "D2.2",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.2.mp3",
        functions: [ ["T", "S"],	["D", "T"], ["T", "S"],	["D", "T"], ["T"] ]
    },



    {
        title: "D2.3",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.3.mp3",
        functions: [ ["T"],	["S"],	["T","D"], ["T","S"],  ["T"] ]
    },

    {
        title: "D2.6",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.6.mp3",
        functions: [ ["T"],	["S"],	["T"], ["D"],  ["T"],	["S"],	["T"], ["D"], ["T"] ]
    },

    {
        title: "D2.10",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.10.mp3",
        functions: [ ["T"],	["S"],	["D"], ["T"] ]
    },

    {
        title: "D2.14",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.14.mp3",
        functions: [ ["T"],	["S", "D"],	 ["T"],	["S", "D"],  ["T"] ]
    },

    {
        title: "D2.17",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.17.mp3",
        functions: [ ["T"],	["T"],	["S"], ["D"],  ["T"],	["T"],	["S"], ["D"], ["T"] ]
    },

    {
        title: "D2.23",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.23.mp3",
        functions: [ ["T", "S"],	["S", "D"],	 ["T", "S"],	["S", "D"],   ["T"] ]
    },

    {
        title: "D2.27",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.27.mp3",
        functions: [ ["T"],	["T"],	["S"], ["S"],  ["D"],	["D"],	["T"], ["T"] ]
    },

    {
        title: "D2.30",
        credits: "Virgo Sillamaa -  \"Kõlakool\". Autori lahkel loal.",
        soundFile: "/sounds/chords/functions/D2.30.mp3",
        functions: [ ["T"],	["T"],	["D"], ["D"],  ["S"],	["S"],	["D"], ["D"], ["T"] ]
    },





];
